import { usePermanentLocations } from "components";

import type { NOTE_SUGGESTION_TYPES } from "models";

export const useNoteSuggestions = (noteSuggestionTypeId?: NOTE_SUGGESTION_TYPES, locationId?: number) => {
  const location = usePermanentLocations().locations.find(l => l.id === locationId);
  if (!noteSuggestionTypeId || !location?.note_suggestions) return [];

  return location.note_suggestions
    .filter(ns => ns.note_suggestion_type_id === noteSuggestionTypeId && ns.active)
    .map(suggestion => ({ text: suggestion.content, value: suggestion.ordering, key: suggestion.ordering }));
};
